import * as yup from 'yup'

export const conceptsForm = yup.object({
  nombre: yup.string().required('Este campo es obligatorio'),
  tipo: yup.string().required('Este campo es obligatorio'),
})
